














import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

@Component
export default class AddButton extends Vue {
  @Prop() disabled!: boolean

  @Emit('addButtonClick')
  onAddButtonClick():boolean {
    return true
  }
}
